// import './Spinner.scss';
import { Spinner as ChakraSpinner } from '@chakra-ui/react';

export default function Spinner({
  size = 'md',
  color,
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
}) {
  return (
    <ChakraSpinner
      variant="mooven"
      size={size}
      verticalAlign="middle"
      color={color}
    />
  );
}
